<template lang="html">
  <div class="Tanfolyamok">

    <Tanfolyamok v-show="Tanfolyamok_show"></Tanfolyamok>

    <TanfolyamokDetails v-show="TanfolyamokDetails_show"></TanfolyamokDetails>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          v-show="Tanfolyamok_show || TanfolyamokDetails_show"
          @click="CreateCourse"
          fixed
          dark
          fab
          bottom
          left
          color="white"
        >
        <img src="https://www.gstatic.com/images/icons/material/colored_icons/1x/create_32dp.png">
        </v-btn>
      </template>
      <span>Új tanfolyam rogzítése</span>
    </v-tooltip>

    <v-btn
      v-show="!Tanfolyamok_show"
      @click="BackCourses"
      fixed
      dark
      fab
      bottom
      right
      color="red"
    >
    <v-icon>undo</v-icon>
    </v-btn>

  </div>
</template>

<script>
import Tanfolyamok from '../components/tanfolyamok.vue'
import TanfolyamokDetails from '../components/tanfolyamok_details.vue'
import store from '../store'
import { mapFields } from 'vuex-map-fields'

  export default {
    components: {
      Tanfolyamok,
      TanfolyamokDetails
    },
    methods: {
      CreateCourse() {
        this.TanfolyamokDetails_show = true
        this.Tanfolyamok_show = false
        this.course_id = null
        this.course_number = null
        this.course_start = null
        this.course_end = null
        this.place_name = null
        this.place_id = null
        this.course_type = null
        this.course_type_id = ''
        this.nkh_course_type_id = ''
        this.course_pattern = null
        this.driving_school_id = null
        this.nkh_user_name = null
      },
      BackCourses() {
        this.TanfolyamokDetails_show = false,
        this.Tanfolyamok_show = true
        this.course_id = null
        this.course_number = null
        this.course_start = null
        this.course_end = null
        this.place_name = null
        this.place_id = null
        this.course_type = null
        this.course_type_id = ''
        this.nkh_course_type_id = ''
        this.course_pattern = null
        this.driving_school_id = null
        this.nkh_user_name = null
      },
    },
    mounted() {

    },
    computed: {
    ...mapFields([
      'showing.TanfolyamokDetails_show',
      'showing.Tanfolyamok_show',
      'tanfolyamok.course_id',
      'tanfolyamok.course_number',
      'tanfolyamok.course_start',
      'tanfolyamok.course_end',
      'tanfolyamok.place_name',
      'tanfolyamok.place_id',
      'tanfolyamok.course_type',
      'tanfolyamok.course_type_id',
      'tanfolyamok.nkh_course_type_id',
      'tanfolyamok.course_pattern',
      'tanfolyamok.driving_school_id',
      'tanfolyamok.nkh_user_name',
  ]),
  },
  }
</script>

<style lang="css">
</style>
